import * as THREE from 'three';
import { G, M, TINT, HP, glowMat, mesh, plate, rib, mergeBones, stages, boneG } from './kit';
/* ============================================================
   KOKON 繭 —— BOSS・剝殼
   ============================================================

   剪影：三層包覆的紡錘
   階段：'P1 厚繭・極慢・幾乎打不穿','P2 外層剝落・開始會躲','P3 只剩核心・比小怪還小但抓不到'

   由 `tools/port-bosses.mjs` 從 `enemy_sample_ani.html` 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-bosses.mjs --check`。
   ⚠️ 比對只守得住數字與字串，**動畫對不對只能實看**（圖鑑的開發模式）。 */


/* ── BOSS-15 KOKON 繭 ── 反直覺：這隻越打越小。
   P1 7.6 單位的厚繭，動作極慢，你幾乎打不穿。
   P2 外層六片剝落，剩 5.2 單位，開始會躲。
   P3 中層也剝掉，只剩 2.6 單位的核心 —— 比大部分小怪還小，但快得抓不到。
   血量條在這隻的意義是「剝殼進度」，不是「傷害進度」。 */
export function buildKokon(){
  var GLA = glowMat(TINT.amb.hex, 2.2), GLV = glowMat(TINT.vio.hex, 2.5);
  var root = new THREE.Group(), outer = [], mid = [], i;
  var hub = boneG(root, 0, 3.60, 0);
  for (i = 0; i < 6; i++){
    var a = i*Math.PI * 2/6;
    var ou = boneG(hub, 0, 0, 0); ou.rotation.y = a;
    ou.add(plate(M.armor, 2.20, 4.60, 0.70, [0, 0, 2.60], 0));
    ou.add(rib  (M.armor, 0.16, 4.20, 0.16, [ 0.98, 0, 3.00]));
    ou.add(rib  (M.armor, 0.16, 4.20, 0.16, [-0.98, 0, 3.00]));
    ou.add(mesh(G.cone, M.trim, [0.40,1.00,0.40], [0, 2.50, 2.90], [0.8,0,0]));
    outer.push(ou);
    var mi = boneG(hub, 0, 0, 0); mi.rotation.y = a + Math.PI * 2/12;
    mi.add(plate(M.armor, 1.50, 3.00, 0.56, [0, 0, 1.70], 0));
    mi.add(rib  (M.dark,  0.14, 2.80, 0.14, [ 0.66, 0, 1.98]));
    var mg = mesh(G.box, GLA, [1.10,0.14,0.12], [0, 0, 2.02]);
    mg.userData.noMerge = 1; mi.add(mg);
    mid.push(mi);
  }
  var core = boneG(hub, 0, 0, 0);
  core.add(mesh(G.tor, M.trim, [2.20,2.20,0.44], [0,0,0], [HP,0,0]));
  core.add(mesh(G.tor, M.trim, [2.05,2.05,0.44], [0,0,0], [0,HP,0]));
  var cm = mesh(G.oct, GLV, [1.60,1.60,1.60], [0,0,0]);
  cm.userData.noMerge = 1; core.add(cm);
  root.userData.rig = {hub:hub, outer:outer, mid:mid, core:core, cm:cm, GLA:GLA, GLV:GLV};
  return mergeBones(root);
}
export function updKokon(rig, o, dt){
  stages(rig, o, dt, 2.2);
  var s1 = rig.s1, s2 = rig.s2, i;
  for (i = 0; i < 6; i++){
    rig.outer[i].visible = s1 < 0.5;
    rig.mid[i].visible   = s2 < 0.5;
    rig.outer[i].rotation.x = 0.10*Math.sin(o.t*1.2 + i) - o.tel*0.24;
    rig.mid[i].rotation.x   = 0.14*Math.sin(o.t*1.9 + i*2) - o.tel*0.34;
  }
  rig.hub.rotation.y += dt*(0.25 + 1.1*s1 + 3.2*s2);
  /* 越小越快：浮沉頻率與幅度都隨階段翻倍 */
  var f = 0.9 + 1.4*s1 + 2.6*s2;
  rig.hub.position.y = (3.60 - 0.70*s1 - 0.55*s2) + (0.18 + 0.34*s2)*Math.sin(o.t*f);
  rig.hub.position.x = (0.30 + 1.40*s2)*Math.sin(o.t*f*0.7);
  rig.cm.scale.setScalar((0.55 + 0.25*s1 + 0.30*s2)*(1 + 0.16*Math.sin(o.t*3.4) + 0.7*o.tel));
  rig.GLA.emissiveIntensity = 2.2 + 2.4*o.tel;
  rig.GLV.emissiveIntensity = 0.8 + 1.8*s1 + 3.0*s2 + 3*o.atk;
}